import ModuleSidebar from './ModuleSidebar.vue';

export default ModuleSidebar;



// WEBPACK FOOTER //
// ./src/components/parts/modules/modulesidebar/index.ts